export enum HostedPageStateEnum {
  CREATED= 'CREATED',
  REQUESTED = 'REQUESTED',
  SUCCEEDED = 'SUCCEEDED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  _UNKNOWN = '_UNKNOWN',
}
